import { Accordion, AccordionDetails, AccordionSummary, Tooltip, Typography } from '@mui/material';
import { ConversationView } from '@my-helpers/common';
import { ElementType } from 'react';
import { SummaryDetail, SummaryFooter, SummaryInfo, SummaryItem } from '../SummaryItem';
import { formatDate } from '@/utils/dateHelpers';

interface ThreadsProps {
	currentConversation?: ConversationView;
	selectThread: (threadId: string) => void;
}

const Threads: ElementType<ThreadsProps> = ({ currentConversation, selectThread }) => {
	const currentThreadId = currentConversation?.currentThread?.id;

	return (
		<Accordion disableGutters>
			<AccordionSummary
				aria-controls="threads-content"
				id="threads-header"
				sx={{
					borderBottom: 1,
					borderColor: 'divider'
				}}
			>
				<Typography
					variant="body1"
					component="span"
					color="text.primary"
				>
					Threads
				</Typography>
			</AccordionSummary>
			<AccordionDetails
				sx={{
					p: 0,
					maxHeight: '33vh',
					overflowY: 'auto',
					backgroundColor: 'background.default'
				}}
			>
				{currentConversation?.threads?.map((thread, index) => (
					<SummaryItem 
						key={thread.id} 
						light={thread.id !== currentThreadId}
						onClick={() => selectThread(thread.id)}
					>
						<Tooltip title={thread.topic} arrow placement="auto">
							<SummaryInfo>
								<Typography variant="body2" color="text.primary">
									{thread.topic}
								</Typography>
							</SummaryInfo>
						</Tooltip>
						<SummaryFooter>
							<SummaryDetail justifyContent="flex-end">
								<Typography variant="caption" color="text.secondary">
									Created: {formatDate(thread.created_at, 'datetime')} 
									<span style={{ margin: '0 4px' }}>•</span>
									Updated: {formatDate(thread.updated_at, 'datetime')}
								</Typography>
							</SummaryDetail>
						</SummaryFooter>
					</SummaryItem>
				))}
			</AccordionDetails>
		</Accordion>
	);
};

export default Threads;
